import { Dispatch, SetStateAction } from 'react';
import {
  Typography,
  useMediaQuery,
  Grid,
  IconButton,
  Box,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { customTheme } from '../theme';
import { ServiceMethod } from '../types/order';
import { LocationText } from '../pages/location-text-display';
import { toTitleCase } from '../utils/string';

interface SeatInfoProps {
  stadium?: string;
  section?: string;
  collectionPoint?: string;
  row?: string;
  seat?: string;
  isClickAndCollectEnabled?: boolean;
  serviceMethod?: string;
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
}

export function SeatInfo({
  stadium,
  serviceMethod,
  isExpanded,
  setIsExpanded,
}: SeatInfoProps) {
  const isSmallScreen = useMediaQuery('(max-width: 360px)');
  const isMediumScreen = useMediaQuery('(max-width: 400px)');
  const { t } = useTranslation(['patron_portal', 'common']);

  // Dynamic font sizing based on screen width
  const stadiumFontSize = isSmallScreen
    ? '12px'
    : isMediumScreen
    ? '14px'
    : '18px';
  const serviceFontSize = isSmallScreen
    ? '11px'
    : isMediumScreen
    ? '13px'
    : '16px';
  const iconFontSize = isSmallScreen
    ? '16px'
    : isMediumScreen
    ? '18px'
    : '28px';
  const showExpand = serviceMethod !== ServiceMethod.COLLECT_FROM_VENDOR;
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} position="relative">
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={0.1}
        >
          <Grid item>
            <Typography
              fontFamily={customTheme.fontFamily}
              fontSize={stadiumFontSize}
              fontWeight={600}
              sx={{
                whiteSpace: 'nowrap',

                maxWidth: 'calc(100% - 50px)',
              }}
            >
              {stadium}
            </Typography>
          </Grid>
          <Grid item>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={0.5}
            >
              <Typography
                fontFamily={customTheme.fontFamily}
                fontSize={serviceFontSize}
                fontWeight={550}
                sx={{
                  whiteSpace: 'nowrap',
                }}
              >
                 {toTitleCase(serviceMethod)}
              </Typography>
              {showExpand && (
                <IconButton
                  onClick={() => setIsExpanded(!isExpanded)}
                  sx={{ padding: 0.1 }}
                >
                  <ExpandMore
                    sx={{
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease-in-out',
                      fontSize: stadiumFontSize,
                      color: 'black',
                    }}
                  />
                </IconButton>
              )}
            </Box>
          </Grid>
          {/* Add LocationText below only when expanded */}
          {isExpanded && (
            <Grid item>
              <LocationText />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
